import { render, staticRenderFns } from "./company-address.vue?vue&type=template&id=47141c23&scoped=true"
import script from "./company-address.vue?vue&type=script&lang=js"
export * from "./company-address.vue?vue&type=script&lang=js"
import style0 from "./company-address.vue?vue&type=style&index=0&id=47141c23&prod&lang=css"
import style1 from "./company-address.vue?vue&type=style&index=1&id=47141c23&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47141c23",
  null
  
)

export default component.exports